import React, { useMemo, useState } from "react"
import Projet from "../../../model/projet"
import { Form } from "semantic-ui-react"
import { SubmitButton } from "../../generic/submit-button"
import { investmentService } from "../../../services/investment-service"
import { useSelector } from "react-redux"
import { ApplicationState } from "../../../store"
import { AuthenticationState } from "../../../model/state/authentication-state"
import { CheckBoxElement, CheckBoxListField } from "../../generic/checkbox-list-field"
import { DemandeDebouclageBody } from "../../../model/dto/body/demande-debouclage-body"
import { FormErrorHeader } from "../../generic/form-error-header"

type Props = {
    projet: Projet
    onSubmitSuccess: (response: Response) => void
}

type FieldData = {
    value?: any,
    name?: string,
    isValid?: boolean
}

type Form = {
    action: FieldData
}

export function DemandeDebouclageForm({projet, onSubmitSuccess}: Props) {
    const [form, setForm] = useState<Form>({
        action: {value: undefined, name: 'action', isValid: true}
    })

    const [isFormError, setIsFormError] = useState(false)
    const [formSubmitted, setFormSubmitted] = useState(false)

    const loginProps: AuthenticationState = useSelector<ApplicationState, AuthenticationState>(state => state.authentication)

    const validateMandatory = (value: any): boolean => {
        return value && value !== ""
    }

    const validateAction = (value: any): boolean => {
        return pourcentage >= 80 || pourcentage < 80 && validateMandatory(value)
    }

    const isFormValid = (): boolean => {
        return validateAction(form.action.value)
    }

    const onFormNotValid = (): void => {
        setIsFormError(true)
    }

    const onSubmitError = (): void => {

    }

    const montant = useMemo(() => {
        return projet.MontantCagnotteActuel! / 100
    }, [])

    const pourcentage = useMemo(() => {
        return Math.round(montant / projet.MontantFinancementCitoyenDemande! * 10000) /100
    }, [])

    const actionList: CheckBoxElement[] = [
    {
        key: 'DBL',
        label: 'Demander le déblocage'
    },
    {
        key: 'ANN',
        label: 'Annuler la collecte'
    }]

    const body: DemandeDebouclageBody = {
        IsAsked: form.action.value ? form.action.value === 'DBL' :  true
    }

    return (
        <Form css={{display: "block"}}>
            <FormErrorHeader 
                message="Veuillez corriger les champs en erreur"
                displayed={isFormError}
            />
            <div>
                Votre période de collecte est maintenant terminée.
            </div>
            <div css={{marginBottom: "20px"}}>
                Vous avez collecté {montant}€, soit {pourcentage}% du montant recherché <br/>
                
            </div>
            {pourcentage < 80 && (
                <>
                    <div>
                    Comme défini dans la convention de mandat signée avec Villyz, vous avez le choix entre débloquer les fonds ou annuler la collecte. 
                    </div>
                    <Form.Field width={16}>
                        <div css={{margin :"20px", marginBottom : '0px'}}>
                        <CheckBoxListField
                            data={form.action}
                            label=""
                            elements={actionList}
                            submitted={formSubmitted}
                            vertical
                            validateField={validateAction}
                            error="Merci de renseigner l'action souhaitée"
                            onChange={(newKey: any) => {
                                setForm({...form, action: {value: newKey, name:'action', isValid: true}})
                                setIsFormError(false)
                            }}
                        />
                        </div>
                    </Form.Field>
                   
                    {form.action.value == 'ANN' 
                    ? 
                    <div css={{textAlign : "left", margin:"10px", fontSize: '1rem'}}> 
                        Les fonds seront intégralement restitués aux citoyens qui seront informés de l'annulation de la campagne de financement
                    </div>
                    :
                    <div></div>
                    }
                </>
            )}
            {pourcentage >= 80 && (
                <div>
                    Comme défini dans la convention de mandat signée avec Villyz, merci de procéder aux démarches de débouclage en cliquant sur le bouton ci-dessous.
                </div>
            )}
            <div css={{textAlign: "center"}}>
                <SubmitButton 
                    data={body}
                    label="Demander le débouclage"
                    onPreSubmit={() => {setFormSubmitted(true)}}
                    action={() => investmentService.askDebouclage(projet.Id!, body, loginProps!.oauth)}
                    validateForm={isFormValid}
                    onFormNotValid={onFormNotValid}
                    onActionSuccess={onSubmitSuccess}
                    onActionFailure={onSubmitError}
                />
            </div>
        </Form>
    )
}
